import { initShaderProgram } from "./gl-utils";

export default class Blur {
  constructor(gl) {
    // Program
    const program = initShaderProgram(
      gl,
      require("./shaders/splash.vert").default,
      require("./shaders/gauss-blur.frag").default
    );
    this.programInfo = {
      program: program,
      attribLocations: {},
      uniformLocations: {
        texture: gl.getUniformLocation(program, "u_Texture"),
        scale: gl.getUniformLocation(program, "u_Scale"),
      },
    };

    this.fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.fbo);

    this.texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, this.texture);

    gl.texImage2D(
      gl.TEXTURE_2D, // target
      0, // level
      gl.R16F, // internal_format
      gl.canvas.width, // width
      gl.canvas.height, // height
      0, // border
      gl.RED, // format
      gl.FLOAT, // ty
      null // pixels
    );

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_BASE_LEVEL, 0);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAX_LEVEL, 4);

    gl.texParameteri(
      gl.TEXTURE_2D,
      gl.TEXTURE_MIN_FILTER,
      gl.LINEAR_MIPMAP_LINEAR
    );
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_R, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    gl.framebufferTexture2D(
      gl.DRAW_FRAMEBUFFER, // target
      gl.COLOR_ATTACHMENT0, // attachment
      gl.TEXTURE_2D, // texture_target
      this.texture, // texture
      0 // level
    );

    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
  }

  apply(gl, texture) {
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.fbo);
    gl.disable(gl.DEPTH_TEST);

    gl.useProgram(this.programInfo.program);

    // Horizontal pass
    gl.framebufferTexture2D(
      gl.DRAW_FRAMEBUFFER, // target
      gl.COLOR_ATTACHMENT0, // attachment
      gl.TEXTURE_2D, // texture target
      this.texture, // texture
      0 // level
    );
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.uniform1i(this.programInfo.uniformLocations.texture, 0);
    gl.uniform2i(this.programInfo.uniformLocations.scale, 1, 0);
    gl.drawArrays(gl.TRIANGLES, 0, 6);

    // Re-generate mipmaps
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.bindTexture(gl.TEXTURE_2D, null);

    // Vertical pass
    gl.framebufferTexture2D(
      gl.DRAW_FRAMEBUFFER, // target
      gl.COLOR_ATTACHMENT0, // attachment
      gl.TEXTURE_2D, // texture target
      texture, // texture
      0 // level
    );
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.uniform1i(this.programInfo.uniformLocations.texture, 0);
    gl.uniform2i(this.programInfo.uniformLocations.scale, 0, 1);
    gl.drawArrays(gl.TRIANGLES, 0, 6);

    // Re-generate mipmaps
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.bindTexture(gl.TEXTURE_2D, null);

    gl.enable(gl.DEPTH_TEST);

    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
  }

  cleanup(gl) {
    gl.deleteFramebuffer(this.fbo);
    gl.deleteTexture(this.texture);
  }
}
